import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { BookingService } from '../service/booking.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { HttpService } from '../service/http.service';
import { Vademecum } from '../vademecum';
import { BrugesVndBooking } from '../bruges-vnd-booking';
import { BookingBrugesService } from '../service/booking-bruges.service';

@Component({
  selector: 'app-view-booking-detail',
  templateUrl: './view-booking-detail.component.html',
  styleUrls: ['./view-booking-detail.component.css']
})
export class ViewBookingDetailComponent implements OnInit {
  booking: BrugesVndBooking | null = null;
  dashboardUrl: string | null = null;
  duration: number | null = null;
  bookingForm: FormGroup | null = null;
  img = new Image();
  picture: SafeResourceUrl | null = null;
  weeks: string = "weeks";

  hasVademecum: boolean = false;

  vademecum: Vademecum | null = null;

  constructor(
    private bookingService: BookingService,
    private sanitizer: DomSanitizer,
    private httpService: HttpService,
    private bookingBrugesService: BookingBrugesService
  ) { }

  ngOnInit() {
    this.booking = this.bookingService.booking as BrugesVndBooking;
    this.dashboardUrl = "https://languesvivantes-bruges.com/" + this.bookingBrugesService.getPathByStudentLanguage(this.booking.student.language) + "/dashboard/" + this.booking.uuid;
    this.duration = Math.round(this.booking.endDate.diff(this.booking.startDate, "weeks", true));
    if(this.duration <= 1){
      this.weeks = "week";
    }

    if(this.booking.studentPicture){
      this.picture = this.sanitizer.bypassSecurityTrustResourceUrl("data:image/png;base64, " + this.booking.studentPicture);
    }

    this.httpService.hasVademecum(this.booking.id!)
    .subscribe(res => {
      this.bookingService.hasVademecum = res;
      if(res == true){
        this.httpService.getVademecumByBookingId(this.booking!.id!)
        .subscribe(vademecum => this.vademecum = vademecum);
      }
    });
    
  }

}
